import React, {Component} from 'react';
import {guideLoadingAttr} from '../guides/anchors';

export class Loading extends Component {
    render() {
        // `guideLoading`: la pantalla entera está cargando y una guía que espera un elemento tiene que
        // esperarla (ver `guideLoadingAttr`). Sólo para el loader de una PANTALLA, no de una sección.
        const marker = this.props.guideLoading ? guideLoadingAttr() : {};
        return (
            <div className="loading-content" {...marker}>
                <p className="loading-message">{this.props.message}</p>
            </div>
        )
    }
}